import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../api/client.jsx';
import { useFixturesMode, fixtureDelay } from '../../api/fixtures';
import { useApiMutation } from '../../api/mutations';
import { driversFixture, updateDriverFixture, removeDriverTenantFixture } from './fixture';

export function useDrivers() {
  const { fetch } = useApiClient();
  const fixturesMode = useFixturesMode();
  return useQuery({
    queryKey: ['drivers', fixturesMode ? 'fixture' : 'live'],
    queryFn: async () => {
      if (fixturesMode) {
        await fixtureDelay();
        return driversFixture();
      }
      return fetch('/v1/admin/drivers');
    },
  });
}

export function useUpdateDriver() {
  return useApiMutation({
    live: (fetch, { key, patch }) =>
      fetch(`/v1/admin/drivers/${encodeURIComponent(key)}`, {
        method: 'PUT',
        body: patch,
      }),
    fixture: ({ key, patch }) => updateDriverFixture(key, patch),
    invalidate: ['drivers'],
    successMessage: 'Driver-Konfiguration gespeichert.',
  });
}

export function useRemoveDriverFromTenant() {
  return useApiMutation({
    live: (fetch, { key }) =>
      fetch(`/v1/admin/drivers/${encodeURIComponent(key)}/tenant`, {
        method: 'DELETE',
      }),
    fixture: ({ key }) => removeDriverTenantFixture(key),
    invalidate: ['drivers'],
    successMessage: 'Driver aus dieser Brand entfernt.',
  });
}
